export const ballastItemLabel = (value) => {
  const label = String(value ?? "").trim();
  const match = label.match(/^\.?(\d+)\.?$/);
  return match ? `${match[1]}.` : label;
};
